module.exports = __webpack_public_path__ + "static/media/Longieren01.55b87223.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Longieren01.jpg
// module id = 348
// module chunks = 0